export enum Platform {
  SOLAR_REVIEWS = "solar_reviews",
  ENERGY_SAGE = "energy_sage",
  OHM_ANALYTICS = "ohm_analytics",
  YELP = "yelp",
  BBB = "bbb",
  GOOGLE = "google",
}
